// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  height: 100px;
  justify-content: center;
  left: 0;
  padding: 10px 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
}

.header-container {
  text-align: center;;
  width: 1400px;
}

.app-logo {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,eAAe;EACf,eAAe;EACf,QAAQ;EACR,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".app-header {\n  background: white;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  height: 100px;\n  justify-content: center;\n  left: 0;\n  padding: 10px 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n}\n\n.header-container {\n  text-align: center;;\n  width: 1400px;\n}\n\n.app-logo {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
